import { Select } from "@/components/atoms";
import type { LevelSelectorProps } from "./types";

export function LevelSelector({ selectedId, levels, onChange, emptyMessage, isLoading, required }: LevelSelectorProps) {
    const uniqueLevels = Array.from(
        new Map(
            levels.map((level) => {
                const key = (level.displayName ?? '').toLowerCase();
                return [key, level] as const;
            })
        ).entries(),
    ).map(([key, level]) => {
        // If the selected level shares this displayName, prefer it over the last-wins default
        if (selectedId != null && level.id !== selectedId) {
            const selected = levels.find((l) => l.id === selectedId && (l.displayName ?? '').toLowerCase() === key);
            if (selected) return selected;
        }
        return level;
    });

    const options = uniqueLevels.map((level) => ({ id: level.id, label: level.displayName }));

    return (
        <Select
            label="Level"
            options={options}
            value={selectedId}
            onChange={(value) => onChange(value as number | null)}
            placeholder="Select level"
            emptyMessage={emptyMessage || "No levels available"}
            isLoading={isLoading}
            required={required}
            searchable
        />
    );
}
